<div class="sw-extension-store-accessibility">
    <strong class="sw-extension-store-accessibility__info">
        {{ $t('sw-extension-store-accessibility.accessibility-text') }}
    </strong>

    <mt-button
        class="sw-extension-store-accessibility__link"
        variant="primary"
        :link="$t('sw-extension-store-accessibility.accessibility-link')"
    >
        {{ $t('sw-extension-store-accessibility.accessibility-more-information') }} <mt-icon name="regular-long-arrow-right" size="12px" />
    </mt-button>
</div>
